var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('Asset',{staticClass:"header-logo",attrs:{"name":"logo.svg","alt":"Logo Parcelex","title":"Logo Parcelex"}}),(_vm.showHeaderHelperIcon)?_c('Icon',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"header-icon",attrs:{"name":"help-gray"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }